/**
 * @file PaddleHub banner代码块
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import copy from 'copy-text-to-clipboard';
import { Tooltip } from 'antd';

import { IBannerCodeContainerProps } from './types';


const hljs = import('highlight.js');

const BannerCodeContainer: FC<IBannerCodeContainerProps> = (props) => {
    const {
        code
    } = props;

    const codeDomRef = useRef<HTMLPreElement>(null);

    useEffect(() => {
        if (codeDomRef.current) {
            hljs.then((hl) => {
                if (codeDomRef.current) {
                    console.log(codeDomRef.current);
                    hl.highlightBlock(codeDomRef.current);
                }
            });
        }
    }, []);

    const [themeDark, setThemeDark] = useState<boolean>(() => {
        if (window.localStorage) {
            const storage = window.localStorage;
            return !!storage.getItem('hub-index-theme-dark');
        }
        return false;
    });

    const [copied, setCopied] = useState<boolean>(false);

    const onCopyClick = useCallback(() => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1000);
        copy(code);
    }, [code, setCopied]);

    const onThemeClick = useCallback(() => {
        setThemeDark((old) => {
            if (window.localStorage) {
                const storage = window.localStorage;
                storage.setItem('hub-index-theme-dark', !old ? '1' : '');
            }
            return !old;
        });
    }, [setThemeDark]);

    return (
        <div className={
            classNames(
                'paddle-banner-code',
                {
                    'paddle-banner-code-theme-dark': themeDark
                }
            )}
        >
            <div className="paddle-banner-code-header">
                您只需几行代码即可重复使用经过训练的模型，例如
                <span className="paddle-banner-code-btns-wrap" >
                    <Tooltip placement="top" title={themeDark ? '浅色代码主题背景' : '深色代码主题背景'}>
                        <i className="paddle-banner-code-btns paddle-banner-code-btns-theme" onClick={onThemeClick} />
                    </Tooltip>
                    <Tooltip placement="top" title={copied ? '已经复制到剪贴板' : '复制'}>
                        <i className="paddle-banner-code-btns paddle-banner-code-btns-copy" onClick={onCopyClick} />
                    </Tooltip>
                </span>
            </div>
            <div className="paddle-banner-code-body">
                <pre
                    className="highlight hljs python"
                    ref={codeDomRef}
                    {...{ dangerouslySetInnerHTML: { __html: code } }}
                />
            </div>
        </div>
    );
};

export default BannerCodeContainer;
